import { buttonVariants } from '@cocoonspace/ui/components/button'
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@cocoonspace/ui/components/card'
import { Trans } from '@lingui/react/macro'
import { LocalizedLink as Link } from '~/components/localized-link'

export const NotFound = () => {
	return (
		<div className='flex flex-1 flex-col items-center justify-center gap-2'>
			<Card>
				<CardHeader>
					<CardTitle>
						<Trans>Lien d'invitation introuvable</Trans>
					</CardTitle>
				</CardHeader>

				<CardContent className='grid gap-y-8'>
					<p>
						<Trans>
							Nous n'avons pas trouvé le lien d'invitation recherché
						</Trans>
					</p>

					<hr />

					<Link
						href='/paris'
						className={buttonVariants({
							className: 'text-sm',
							variant: 'link',
						})}
					>
						<Trans>Réserver un Cocoon</Trans>
					</Link>
				</CardContent>
			</Card>
		</div>
	)
}
